/**
 * InfoField - Displays a label/value pair
 * Consistent styling for read-only information display
 */
export default function InfoField({ label, value, className = '' }) {
  return (
    <div className={className}>
      <label className="text-sm max-lg:text-xs text-gray-400 mb-1 max-lg:mb-0.5 block">{label}</label>
      <div className="text-white max-lg:text-sm">{value || 'Not set'}</div>
    </div>
  );
}
